import { render } from "./disabling.md?vue&type=template&id=df842960"
import script from "./disabling.md?vue&type=script&lang=js"
export * from "./disabling.md?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__